import React, { Fragment, useEffect, useState, useCallback, useRef } from 'react';
import connect from 'react-redux/lib/connect/connect';
import { SetPageInfo } from '../../common/actions/pageAction';
import { GetSportsList } from '../../common/actions/sportsAction';
import { clearInfiniteScroll, convertGameType, fixBetGameData, groupBetGameEvents, isEmpty, isMobilePage, mobileSportsListScrollHandler, mobileSportsWindowScrollHandler, pcSportScrollHandler, ResizeESportsIframe, ResizeSportsLiveIframe } from '../../common/cores';
import { per_page } from '../../common/cores/keys';
import { socket } from '../../common/cores/socket';
import Markets from './Markets';
import Match from './Match';
import Swipbox from './Swipbox';
import Pagenation from '../common/Pagenation';
import { getEventParttName, getMarketName } from '../../common/actions/userActions';
import $ from "jquery";
import { sportPerPage } from '../../utils';
import { SetCurrentPage, SetPerPage } from '../../common/actions/pageAction';
import { AddSportsList, SetLeague, SetLocation } from '../../common/actions/sportsAction';


const SportsCenter = (props) => {

    const roomObj = props.roomObj;

    const { type, sportsData, location, league, sportId, bet_setting, pageInfo, totalPage, url, isUp, page, searchType, searchValue } = props;

    const [sort, setSort] = useState("time");
    const [esport, setEsport] = useState("prematch");
    const [pages, setPages] = useState(1);
    const [showMarkets, setShowMarkets] = useState(window.screen.width > 800 ? true : false);
    const [interiorShowMarket, setInteriorShowMarket] = useState(-1)
    const [showMatch, setShowMatch] = useState(true);
    const scrollContainerRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0); // 스크롤 상단 위치
    const [isBottom, setIsBottom] = useState(false);

    const listStyle = {
        float: 'left',
        width: '100%',
        margin: '0 0 0 0',
        display: 'block',
        overflow: 'auto',
        minHeight: type == "prematch" ? '550px' : '50px',
        maxHeight: type == "prematch" ? 'calc(100vh - 20rem)' : 'calc(100vh - 50rem)'
    }


    const onInteriorShowMarket = (index) => {
        if (interiorShowMarket === index) {
            setInteriorShowMarket(-1)
        } else {
            setInteriorShowMarket(index)
        }
    }

    useEffect(() => {
        getMarketName();
        getEventParttName();
        props.SetCurrentPage({ page: pages, ...totalPage });
    }, [])

    useEffect(() => {
        props.SetCurrentPage({ page: pages, ...totalPage });
    }, [pages])

    let gamelists = sportsData;

    const getSportsList = (page) => {
        const params = {
            ...roomObj,
            sportId: props.type === "esports" ? "all" : sportId.toString(),
            esportType: props.type === "esports" ? sportId.toString() : "all",
            sort: sort,
            location: location,
            league: league,
            page: page,
            searchType: searchType,
            searchValue: searchValue,
            perPage: sportPerPage,
            gameType: roomObj.gameType
        }
        props.AddSportsList(params, page.curPage == 1, page.curPage != 1);
    }

    const onSort = (sort) => {
        setSort(sort);
        setPages(1);
    }
    useEffect(() => {
        getSportsList(isEmpty(page.curPage) ? 1 : page.curPage);
    }, [sort, page.curPage, sportId, location, league, pageInfo.gameType, searchType, searchValue]);


    const onShowMatch = useCallback(
        () => {
            // if (isMobilePage()) {
            //     window.addEventListener("scroll", mobileSportsWindowScrollHandler)
            // }
            setShowMatch(true)
            setShowMarkets(false)
        }, [showMatch, showMarkets]

    )

    const onShowMarket = useCallback(
        () => {
            setShowMatch(false);
            setShowMarkets(!showMarkets);
        }, [showMarkets, showMatch]
    )
    useEffect(() => {
        ResizeSportsLiveIframe();
        ResizeESportsIframe();
    }, [showMarkets])

    useEffect(() => {
        if (isMobilePage()) {
        }
    }, [])

    const setPage = (curPage) => {
        props.SetCurrentPage({ page: curPage, ...totalPage });
    }

    const handleScroll = () => {
        const scrollTop = scrollContainerRef.current.scrollTop;
        const scrollHeight = scrollContainerRef.current.scrollHeight;
        const clientHeight = scrollContainerRef.current.clientHeight;

        const appWidth = $(".App").innerWidth();
        const windowWidth = window.innerWidth;
        $(".napam-to-page-top").css('right', '' + ((windowWidth - appWidth) / 2 + 20) + 'px');

        setScrollTop(scrollTop);

        if (scrollTop + clientHeight >= scrollHeight) {
            setIsBottom(true);
        } else {
            setIsBottom(false);
        }
    };

    const smoothScrollToTop = () => {
        const scrollContainer = scrollContainerRef.current;
        const targetScrollTop = 0; // 목표 스크롤 위치 (맨 위)
        const currentScrollTop = scrollContainer.scrollTop; // 현재 스크롤 위치
        const distance = targetScrollTop - currentScrollTop; // 이동해야 할 거리
        const duration = 500; // 애니메이션 지속 시간 (ms)
        const startTime = performance.now(); // 애니메이션 시작 시간

        // 애니메이션 업데이트 함수
        const animateScroll = (currentTime) => {
            const elapsed = currentTime - startTime; // 경과 시간
            const progress = Math.min(elapsed / duration, 1); // 애니메이션 진행 정도 (0 ~ 1)

            // easing 함수 (이징 함수로 부드럽게 이동)
            const easing = progress < 0.5 ? 4 * progress * progress * progress : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1;

            // 스크롤 위치를 비율에 맞게 업데이트
            scrollContainer.scrollTop = currentScrollTop + distance * easing;

            // 애니메이션이 완료될 때까지 반복
            if (progress < 1) {
                requestAnimationFrame(animateScroll); // 계속해서 애니메이션을 실행
            }
        };

        // 애니메이션 시작
        requestAnimationFrame(animateScroll);
    };

    const scrollToTop = () => {
        // scrollContainerRef.current.scrollTop = 0;
        smoothScrollToTop();
        setIsBottom(false);
    }

    useEffect(() => {
        const scrollContainer = scrollContainerRef.current;
        scrollContainer.addEventListener('scroll', handleScroll);

        return () => {
            scrollContainer.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        if (!isBottom) {
            $('.napam-to-page-top').removeClass('show');
            $('.napam-to-page-top').addClass('hide');
        }
        else {
            $(".napam-to-page-top").removeClass("hide");
            $(".napam-to-page-top").addClass("show");
        }
    }, [isBottom])

    return (
        <div className="contents_box_left">
            <Swipbox type={type} esport={esport} />
            <div className="sport_betting_area" ref={scrollContainerRef}>
                <div style={{ maxWidth: "800px", margin: "auto" }}>
                    <div className="sport_betting_area_box">
                        {type === "prematch" ? ""
                            : <div id={"sportsLive_iframe_parent"} data-v-183c8283="" data-v-69582644="" className="iframe-view row" style={{ display: "block" }}>
                                <iframe
                                    className="frameScale"
                                    scrolling="no"
                                    frameBorder="0"
                                    width="100%"
                                    height="100%"
                                    src={url}
                                    title={`${"sportsLive"}Iframe`}
                                />
                            </div>}
                    </div>
                </div>
                <div className="sport_betting_area_box">
                    <div className="sport_table_head">
                        <ul>
                            <li className="sport_th1">날짜</li>
                            <li className="sport_th2">승무패</li>
                            <li className="sport_th3">홈</li>
                            <li className="sport_th4">배당</li>
                            <li className="sport_th5">원정</li>
                            <li className="sport_th6">더보기</li>
                        </ul>
                    </div>
                </div>
                <div className='list-parent' style={isMobilePage() ? {} : listStyle}>
                    <div className='sport_title_wrap' style={{ border: 'none', minHeight: '10px' }}></div>
                    {
                        gamelists.map((list, index) => {
                            return (
                                <Fragment key={list.FixtureId}>
                                    <Match
                                        type={type}
                                        key={list.FixtureId}
                                        gamelist={list}
                                        keyIndex={index}
                                        onShowMarket={onShowMarket}
                                        onShowMatch={onShowMatch}
                                        onInteriorShowMarket={onInteriorShowMarket}
                                        interiorShowMarket={interiorShowMarket === index}
                                        showLeague={((index === 0)) ? true : (list.Fixture.League.Id !== gamelists[index - 1].Fixture.League.Id) || (list.Fixture.StartDate !== gamelists[index - 1].Fixture.StartDate)} />
                                    <Markets type={type} showMarkets={showMarkets} interiorShowMarket={interiorShowMarket === index} onShowMarket={onShowMarket} />
                                </Fragment>
                            )
                        })
                    }
                    <div className='sport_title_wrap' style={{ border: 'none', minHeight: '50px' }}></div>
                </div>
            </div>
            <div data-v-216d8a58="" className="pagination-out column">
                <div data-v-3badc2f2="" data-v-216d8a58="" className="pagination row"
                    style={{ flexDirection: "row", alignItems: "center" }}>
                    <div style={{ margin: "0px auto", width: "100%", paddingLeft: "10px" }}>
                        <Pagenation page={page.curPage}
                            totalPage={page.totalPage}
                            getPage={setPage}
                            perPage={100} />
                    </div>
                </div>
            </div>
            <a className='napam-to-page-top hide' onClick={() => scrollToTop()} style={{ right: '20px' }}>
                <img src="../images/common/top.png" style={{ width: '60px', height: '60px' }} />
            </a>
        </div>
    );
};

const mapStateToProps = state => ({
    sportsData: state.sports.data,
    location: state.sports.location,
    searchType: state.sports.searchType,
    searchValue: state.sports.searchValue,
    league: state.sports.league,
    sportId: state.sports.sportId,
    bet_setting: state.sports.bet_setting,
    baselineSetting: state.sports.baselineSetting,
    marketSetting: state.sports.marketSetting,
    page: state.page,
    isUp: state.page.isUp,
    totalPage: state.page.totalPage,
    pageInfo: state.page.pageInfo,
});

export default connect(mapStateToProps, {
    SetLeague,
    SetLocation,
    SetCurrentPage,
    SetPerPage,
    AddSportsList
})(SportsCenter);


// WEBPACK FOOTER //
// ./src/components/sports/SportsCenter.js